import type { FunctionComponent } from "react"

import styles from "./Raw.module.css"

type RawProps = {
  value: number
}

export const Raw: FunctionComponent<RawProps> = props => {
  const { value } = props

  return (
    <div className={styles.wrapper}>
      <span className={styles.value}>{value}</span>
    </div>
  )
}
